// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4941":"9503a00f","9542":"b510cf14"}[chunkId] + ".chunk.css";
};